import { TextField } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

export default function WarehouseCodePrefixSettings({ prefix, onChange }) {
  const { t } = useTranslation();

  return (
    <TextField
      fullWidth
      label={t("CodePrefix")}
      value={prefix}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{ maxLength: 30 }}
    />
  );
}
